module.exports = __webpack_public_path__ + "img/0040.424ac9ed.jpg";